import { mdiFileDocument } from '@mdi/js'

export default [
  {
    title: 'Reports',
    icon: mdiFileDocument,
    children: [
      {
        title: 'DigitalCurrency',
        to: 'digital-currency',
        permission: 'Permissions.ContactRead',
      },
      {
        title: 'OperatorReport',
        to: 'operator-report',
        permission: 'Permissions.OrderRead',
      },
      {
        title: 'PaymentReconciliation',
        to: 'payment-reconciliation',
        permission: 'Permissions.PaymentReconciliationRead',
      },
    ],
  },
]
